import { IFavoriteUnit } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('favourite-unit');

export const createFavouriteAction = actionCreator.async<{ unitId: number }, IFavoriteUnit>(constants.CREATE_FAVOURITE);
export const deleteFavouriteAction = actionCreator.async<{ unitId: number }, void>(constants.DELETE_FAVOURITE);
